import type { RouteRecordRaw } from "vue-router"

const Layout = () => import("@/layout/index.vue")
const Business = () => import("@/views/page/business/index.vue")
const BusinessOrder = () => import("@/views/page/business/Order/index.vue")
const BusinessProductOrder = () => import("@/views/page/business/ProductOrder/index.vue")
const BusinessProductSellout = () => import("@/views/page/business/ProductSellout/index.vue")

const BUSINESS_HIDDEN_ROLE_PROFILES = ["finance"]
export const PRODUCT_SELLOUT_PERMISSION = "business_product_sellout"

const business: RouteRecordRaw[] = [
  {
    path: "/business",
    component: Layout,
    redirect: "/business/index",
    children: [
      {
        path: "index",
        component: Business,
        name: "Business",
        meta: {
          title: "营业",
          showTag: true,
          svgIcon: "nav-business",
          permissions: ["business"],
          hiddenRoleProfiles: BUSINESS_HIDDEN_ROLE_PROFILES,
          keepAlive: true,
          // 使用案例
          extPermissions: [
            {
              key: "business_table_open",
              refresh: "force",
            },
            {
              key: "business_table_place_product",
              refresh: "silent",
            },
          ],
        },
      },
      {
        path: "order/:tableId",
        component: BusinessOrder,
        name: "BusinessOrder",
        meta: {
          title: "营业",
          hidden: true,
          permissions: ["business"],
          hiddenRoleProfiles: BUSINESS_HIDDEN_ROLE_PROFILES,
        },
      },
      {
        path: "product-order",
        component: BusinessProductOrder,
        name: "BusinessProductOrder",
        meta: {
          title: "商品销售",
          hidden: true,
          permissions: ["business"],
          hiddenRoleProfiles: BUSINESS_HIDDEN_ROLE_PROFILES,
        },
      },
      {
        path: "product-sellout",
        component: BusinessProductSellout,
        name: "BusinessProductSellout",
        meta: {
          title: "商品沽清",
          hidden: true,
          permissions: [PRODUCT_SELLOUT_PERMISSION],
          hiddenRoleProfiles: BUSINESS_HIDDEN_ROLE_PROFILES,
        },
      },
    ],
    meta: {
      order: 1,
      permissions: ["business"],
      hiddenRoleProfiles: BUSINESS_HIDDEN_ROLE_PROFILES,
    },
  },
]

export default business
